import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class SubscriptionUser extends Model {
  [Type] = 'subscription-user' as const;

  @attr('string') declare accessRight: string;
  @attr('string') declare email: string;
  @attr('string') declare firstName: string;
  @attr('boolean') declare hasBiBenchmarkingAccess: boolean;
  @attr('boolean') declare hasRateInsightAccess: boolean;
  @attr('boolean') declare isLocked: boolean;
  @attr('string') declare lastActive: string | null;
  @attr('string') declare lastName: string;
}
